import pickBy from "lodash/pickBy";

export const cleanObj = (obj: Record<string, any>) =>
  pickBy(obj, (v) => v !== undefined);
